export const tagGroupStyles = {
  display: 'inline-flex',
  flexWrap: 'nowrap',
  gap: '8px',
  alignItems: 'center',
}

export const tagGroupWrapStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}

export const tagGroupNoWrapStyles = {
  display: 'flex',
  overflow: 'hidden',
  position: 'relative',
}
